import styled from 'styled-components'

import { ButtonSubmit } from '@subaio/components/src/HookForm'

import { solidStyle } from '../Solid'

export const ButtonSolidSubmit = styled(ButtonSubmit)`
	${solidStyle}
`
